import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { AdminService, BaseComponent, UserService } from "@mypxplat/xplat/core";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-content-product-association",
  templateUrl: "content-product-association.component.html",
  standalone: false,
})
export class ContentProductAssociationComponent extends BaseComponent {
  @Input() contentId: number;
  @Input() contentType: string = "video";
  @Input() products: Array<any> = [];

  public associatingProduct: any = false;
  public removingProductAssociationMap: any = {};
  public associateWithProductLine: boolean = true;

  constructor(
    userService: UserService,
    public adminService: AdminService
  ) {
    super(userService);
  }

  associateProduct(event: { product: any; useProductLine: boolean }) {
    const product = event.product;
    this.associatingProduct = product;
    const useProductLine = event.useProductLine;
    const identifier = useProductLine ? String(product.productNo) : String(product.id);
    const identifierType = useProductLine ? "product_no" : "id";
    this.adminService
      .productAssociation({ contentId: this.contentId, contentType: this.contentType, productIdentifier: identifier, productIdentifierType: identifierType, associate: true })
      .subscribe(() => {
        const displayEntry = useProductLine ? { id: product.productNo, title: product.title, imageUrl: product.imageUrl, DTYPE: "ProductLine", product_identifier_type: "product_no" } : product;
        this.products.push(displayEntry);
        this.associatingProduct = false;
      });
  }

  removeProductAssociation(product) {
    if (this.removingProductAssociationMap[product.id]) return;
    this.removingProductAssociationMap[product.id] = true;
    const isProductLine = product.DTYPE === "ProductLine" || product.product_identifier_type === "product_no";
    const identifierType = isProductLine ? "product_no" : "id";
    this.adminService
      .productAssociation({ contentId: this.contentId, contentType: this.contentType, productIdentifier: String(product.id), productIdentifierType: identifierType, associate: false })
      .subscribe(() => {
        this.products.splice(this.products.indexOf(product), 1);
        delete this.removingProductAssociationMap[product.id];
      });
  }
}
